export enum ApplicationStatus {
  WAITING_FOR_APPROVAL = "WaitingForApproval",
  COMPANY_APPROVED = "CompanyApproved",
  COMPANY_REJECTED = "CompanyRejected",
  COMPANY_CANCELLED = "CompanyRejected",
  STUDENT_CANCELLED = "StudentCancelled",
  WAITING_FOR_SCHOOL_APPROVAL = "WaitingForSchoolApproval",
  WAITING_FOR_COMPANY_APPROVAL = "WaitingForCompanyApproval",
}
